import { Button, Page } from '@ui/themed';
import { t } from 'i18next';
import { useHandlers, useSite, withPageProviders } from '../../../context/page-context';
import { trackUpgradeClicked } from '../../../lib/mixpanel';
import { CustomersSearchTable } from '../components/customers-search-table';
import { SalesAgentAvailabilityAlert } from '../components/sales-agent-availability-alert';
import { CUSTOMER_ROLE_TYPE } from '../constants';
import { useSalesAgentsAvailability } from '../hooks/use-sales-agent-availability';

const SALES_AGENTS_LEARN_MORE_URL = 'https://docs.sparklayer.io/sales-agent-ordering';

export const CustomerSalesAgentsOverviewPage = withPageProviders(() => {
  const { navigationHandler } = useHandlers();
  const site = useSite();
  const { data: availability } = useSalesAgentsAvailability();

  const noAgentsInPlan = availability?.max === 0;

  return (
    <Page
      title={t('features:customers.pages.sales_agent_overview_page.title')}
      description={t('features:customers.pages.sales_agent_overview_page.description')}
      learnMoreUrl={SALES_AGENTS_LEARN_MORE_URL}
      footerDescription={t('features:customers.pages.sales_agent_overview_page.footer')}
    >
      <SalesAgentAvailabilityAlert />
      <CustomersSearchTable
        baseSearchRequest={{ role_type: CUSTOMER_ROLE_TYPE.SALES }}
        caption={t('features:customers.pages.sales_agent_overview_page.customers_table.caption')}
        emptyState={{
          title: t(
            noAgentsInPlan
              ? 'features:customers.pages.sales_agent_overview_page.empty_state.no_agents_available.title'
              : 'features:customers.pages.sales_agent_overview_page.empty_state.agents_available.title',
          ),
          subtitle: t(
            noAgentsInPlan
              ? 'features:customers.pages.sales_agent_overview_page.empty_state.no_agents_available.subtitle'
              : 'features:customers.pages.sales_agent_overview_page.empty_state.agents_available.subtitle',
          ),
          imageType: 'salesAgent',
          children: (
            <div className="flex flex-row items-center gap-3">
              {noAgentsInPlan ? (
                <Button
                  icon="upgrade"
                  onClick={() => {
                    trackUpgradeClicked(site, 'Sales Agents');
                    navigationHandler.navigateById('plan');
                  }}
                >
                  {t('buttons:upgrade')}
                </Button>
              ) : (
                <Button onClick={() => navigationHandler.navigate('/customers/list')}>
                  {t(
                    'features:customers.pages.sales_agent_overview_page.empty_state.agents_available.add_button',
                  )}
                </Button>
              )}
              <Button
                variant="secondary"
                onClick={() => window.open(SALES_AGENTS_LEARN_MORE_URL, '_blank')}
              >
                {t('links:learn_more')}
              </Button>
            </div>
          ),
        }}
      />
    </Page>
  );
});
